var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"game-content"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":item.src}})]),_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(item.name))]),_c('p',[_vm._v(_vm._s(item.brief))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }